type Props = {
  name: string;
  iconMap: Record<string, React.ComponentType<any>>;
  size?: number;
  color?: string;
};

export const normalizedName = (name: string) => {
  return name.trim().replace(/\s+/g, '');
};

export const MapIcon = ({
  name,
  iconMap,
  size = 24,
  color = '#575758',
}: Props) => {
  const IconComponent = iconMap[normalizedName(name)];
  if (!IconComponent) return null;

  return (
    <IconComponent
      sx={{ fontSize: size, color }}
      width={size}
      height='auto'
      fill={color}
    />
  );
};
